import React from 'react';
import CommonModuleManager from '../utilities/CommonModuleManager';
import Button from '../form_components/Button';
import Switch from '../form_components/Switch';

export default class CommonModuleInstallOptions extends React.Component {

    /**
     * Allow users to Configure Common Modules during import and version changing
     * @module CommonModuleInstallOptions
     * @param {Object} props React props
     */

    constructor(props){
        super(props);
        this.commonModuleManager = new CommonModuleManager();
        this.state = {
            redactSensitive: false
        }
    }

    setConfig(key, value){
        if(key === "redactSensitive"){ // turn off if on in the Como
            this.props.commonModule.sensitiveOverrides.enabled = !value;
            this.setState({redactSensitive: value});
            this.props.handleOnChangeConfig(key, value);
        }
    }

    /**
     * Applies user-selected install options to Common Modules during import and version change
     */
    handleContinue(){
        let commonModule = this.props.commonModule;
        const previousCommonModule = this.props.previousCommonModule;
        const disableRedaction = this.state.redactSensitive;
        
        // import is from NewElementDialog
        if(this.props.type === "import"){
            this.commonModuleManager.importCommonModule(commonModule, null, disableRedaction);
        } 
        // versionChange is from CommonModuleChangeVersionDialog
        if(this.props.type === "versionChange"){
            this.commonModuleManager.changeCommonModuleVersion(commonModule, previousCommonModule, disableRedaction);
        }
    }

    render(){
    
        return (
            <div className="installOptions">
                <div className="body">
                    
                    {/* options */}
                    <div className="options">
                        <h4> <i className={"fe icon-alert-triangle"} />  Sensitive Data Override </h4> 
                        <p>This Common Module treats some data as sensitive.</p>
                        <p>All data in Common Module will be logged in plain text.</p>
                        <p>Select <b>Disable Sensitive Data Redaction</b> to disable sensitive fields in this common module.</p>
                        <Switch 
                            label="Disable Sensitive Data Redaction"
                            context={this}
                            valKey="redactSensitive"
                            checked={this.state.redactSensitive}
                        />
                    </div>

                </div>

            </div>
        )
    }
    
}